import store from '@/store'

/**
 * 检查当前用户是否拥有指定权限
 * @param {string[]} permissions - 需要的权限code列表（满足其一即可）
 * @returns {boolean}
 */
export function checkPermission(permissions) {
  if (!permissions || !permissions.length) {
    return true
  }

  const userInfo = store.state.user.userInfo
  // 主账号拥有所有权限
  if (userInfo && userInfo.isPrimary) {
    return true
  }

  const userPermissions = store.state.user.permissions || []
  return permissions.some(code => userPermissions.includes(code))
}

/**
 * v-permission 按钮权限指令
 * 用法：v-permission="['order_create']"
 * 无权限时移除 DOM 元素
 */
const permission = {
  inserted(el, binding) {
    const { value } = binding
    if (!checkPermission(value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export default permission
